import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TariffSummaryParts, TariffTextItem } from '../../../../assets/js/com/ts_api_client';
import { VERBRAUCHSTYP } from '../../enums/verbrauchstyp.enum';
import { DatadogService } from '../../services/datadog.service';
import { getInfoIText } from '../../services/tariff-advisor.service';

@Component({
    selector: 'bdo-tariff-price-cap',
    templateUrl: './tariff-price-cap.component.html',
    styleUrls: ['./tariff-price-cap.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TariffPriceCapComponent implements OnInit {
  @Input() tariffDataParts: TariffSummaryParts;
  @Input() isGewe: boolean;
  @Input() division: string;
  @Input() infois: Array<TariffTextItem>;
  public priceCapInfo: string = '';
  public hasBonus: boolean;

  constructor(
    public datadogService: DatadogService
  ) { }

  ngOnInit(): void {
    this.hasBonus = this.tariffDataParts?.contractPayments.some(elem => elem.description.length > 0);

    let tariffTextKey: string = '';
    switch (this.division) {
      case VERBRAUCHSTYP.Strom:
        tariffTextKey = 'priceBrake_E';
        break;
      case VERBRAUCHSTYP.Gas:
        tariffTextKey = 'priceBrake_G';
        break;
    }

    if (tariffTextKey) {
      this.priceCapInfo = getInfoIText(this.infois, tariffTextKey);
    } else {
      this.datadogService.trackCustomEvent('Show PriceCap Info-I: Division ' + this.division + ' has no key in tariffSummary infois.');
    }
  }

}
